import { render, staticRenderFns } from "./product-detail-invoice.vue?vue&type=template&id=fb7e3422&scoped=true"
import script from "./product-detail-invoice.vue?vue&type=script&lang=js"
export * from "./product-detail-invoice.vue?vue&type=script&lang=js"
import style0 from "./product-detail-invoice.vue?vue&type=style&index=0&id=fb7e3422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7e3422",
  null
  
)

export default component.exports